
const EventColumns = [
    "Header Group",
    "Header Name",
    "Value"
  ];

  const EventDataColumns = [
    {
      title: (
        <span
          style={{
            color: !EventColumns.includes("Header Group")
              ? "red"
              : "inherit",
          }}
        > 
          Header Group
        </span>
      ),
      dataIndex: "Header Group",
      key: "1",
      fixed: "left",
      width: 80,
      ellipsis: true,
    },
   
    {
      title: (
        <span
          style={{
            color: !EventColumns.includes("Header Name")
              ? "red"
              : "inherit",
          }}
        >
          Header Name
        </span>
      ),
      dataIndex: "Header Name",
      key: "2",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: !EventColumns.includes("Value")
              ? "red"
              : "inherit",
          }}
        >
          Value
        </span>
      ),
      dataIndex: "Value",
      key: "3",
      width: 100,
    }
  ];
  
  export default { EventDataColumns, EventColumns };